import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/tools/kalkulator-hari")({
  beforeLoad: () => {
    throw redirect({ to: "/en/tools/day-calculator" } as any as any);
  },
  component: () => null,
});
